import React from "react";
import { NavLink } from 'react-router-dom';
function LoginForgetPasswordCom(){
    return(
        <NavLink className="reset-psw" to="/forget-password">Forgot your password?</NavLink>
    )
}

export default LoginForgetPasswordCom;